module.exports = __webpack_public_path__ + "a4071c603c945393d8a0e899af2a6024.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/routes/Confirmation/community.png
// module id = 1048
// module chunks = 0